export default __webpack_public_path__ + "static/media/stride_breaker.19a48d30.png";